import { Component, Injector, Input, Optional } from '@angular/core';

import { InstrumentPrijsHistorieService } from 'src/app/core/service/instrument-prijs-historie.service';
import { InstrumentPrijsHistorie } from 'src/app/core/dto/instrument-prijs-historie';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { InstrumentDefinitie } from 'src/app/core/dto/instrument-definitie';

@Component({
    selector: 'c-i-j-borculo-instrument-prijs-historie-collection',
    templateUrl: './instrument-prijs-historie-collection.component.html'/*,
    styleUrls: ['./instrument-prijs-historie-collection.component.css'] */
})
export class InstrumentPrijsHistorieCollectionComponent extends PagedCollectionComponent<InstrumentPrijsHistorie> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<InstrumentPrijsHistorie>([
		{ colDef: 'type', prop: x => x.type, searchable: SearchableType.String },
		{ colDef: 'prijs', prop: x => x.prijs, searchable: SearchableType.Number },
		{ colDef: 'datum', prop: x => x.datum, searchable: SearchableType.Date }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: InstrumentPrijsHistorieService, @Optional() protected filter: Filter<InstrumentPrijsHistorie>, injector: Injector) {
        super('/instrumentPrijsHistorie/instrumentPrijsHistorie', injector, InstrumentPrijsHistorie);

        this.initInput('instrumentDefinitieID', this.filterBuilder.equal(x => x.instrumentDefinitieID.id));
        this.orderBy = [-3];

        this.filter.onGetChipLabel(x => x.prijs, () => 'Prijs');
		this.filter.onGetChipLabel(x => x.datum, () => 'Datum');
		this.filter.onGetChipLabel(x => x.type, () => 'Type');
    }
   
    @Input() set instrumentDefinitieID(val: InstrumentDefinitie) { this.handleInput('instrumentDefinitieID', val.id); }

    canDelete() {
        return false;
    }

}